module.exports = __webpack_public_path__ + "media/paws/paws-bottom-right-71210b63.svg";